import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

const Contact = () => (
  <section className="section contact__v2" id="contact">
    <Container>
      <Row className="mb-5">
        <Col md={6} lg={7} className="mx-auto text-center">
          <span className="subtitle">Contact</span>
          {/*<h2 className="h2 fw-bold mb-3">Contact Us</h2>*/}
		   <h4 className="h2 fw-bold mb-3">We’re Here to Help Anytime, Anywhere</h4>
          <p>We’re Here to Help - Anytime, Anywhere
Have questions, need support, or want to know more about how HamaraBillBook can benefit your business? Our team is just a message away. Whether you're starting out or already using our platform, we’re happy to assist you.
</p>
        </Col>
      </Row>
      <Row>
<Col md={6}>
  <div className="d-flex gap-5 flex-column">
    <div className="d-flex align-items-start gap-3">
      <div className="icon d-block"><i className="bi bi-whatsapp"></i></div>
      <span>
        <span className="d-block">WhatsApp</span>
        <strong>
          <a href="https://wa.me/919414419941" className="text-decoration-none text-dark">
            +91 94144 19941
          </a>
        </strong>
      </span>
    </div>
    <div className="d-flex align-items-start gap-3">
      <div className="icon d-block"><i className="bi bi-telephone"></i></div>
      <span>
        <span className="d-block">Landline</span>
        <strong>
          <a href="tel:+915644354488" className="text-decoration-none text-dark">
            05644 354488
          </a>
        </strong>
      </span>
    </div>
    <div className="d-flex align-items-start gap-3">
      <div className="icon d-block"><i className="bi bi-send"></i></div>
      <span>
        <span className="d-block">Email</span>
        <strong>
          <a href="mailto:info.hamarabill@gmail.com" className="text-decoration-none text-dark">
            info.hamarabill@gmail.com
          </a>
        </strong>
      </span>
    </div>
    <div className="d-flex align-items-start gap-3">
      <div className="icon d-block"><i className="bi bi-geo-alt"></i></div>
      <div>
        <span className="d-block">Address</span>
        <address className="fw-bold mb-0">
          <a
            href="https://www.google.com/maps/search/?api=1&query=1+M+60+STC+HOUSING+BOARD+RIICO+Road+Bharatpur+321001"
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none text-dark"
          >
            1 M 60 STC HOUSING BOARD,<br />
            RIICO Road, Bharatpur 321001,<br />
            Rajasthan
          </a>
        </address>
      </div>
    </div>
  </div>
</Col>


        <Col md={6}>
          <div className="form-wrapper pt-5">
            <Form onSubmit={async (e) => {
              e.preventDefault();
              const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
              const form = e.currentTarget;
              const name = form.name.value.trim();
              const email = form.email.value.trim();
              const subject = (form.subject.value || '').trim();
              const message = form.message.value.trim();
              const phone = (form.phone?.value || '').trim();
              if (!name || !email || !message) return;
              const btn = form.querySelector('button[type="submit"]');
              const prev = btn.innerText; btn.disabled = true; btn.innerText = 'Sending…';
              try {
                const res = await fetch(`${API_BASE_URL}/api/contact`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    name, email, phone: phone || undefined,
                    message: subject ? `${subject}\n\n${message}` : message,
                  })
                });
                if (res.ok) {
                  alert('Thanks! Your message has been sent.');
                  form.reset();
                } else {
                  const data = await res.json().catch(() => ({}));
                  alert(data?.message || 'Failed to send message');
                }
              } catch (err) {
                alert('Network error. Please try again.');
              } finally {
                btn.disabled = false; btn.innerText = prev;
              }
            }}>
              <Row className="gap-3 mb-3">
                <Col md={12}>
                  <Form.Group controlId="name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" name="name" required />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" name="email" required />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group controlId="phone">
                    <Form.Label>Phone (optional)</Form.Label>
                    <Form.Control type="tel" name="phone" />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="gap-3 mb-3">
                <Col md={12}>
                  <Form.Group controlId="subject">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control type="text" name="subject" />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="gap-3 gap-md-0 mb-3">
                <Col md={12}>
                  <Form.Group controlId="message">
                    <Form.Label>Message</Form.Label>
                    <Form.Control as="textarea" name="message" rows={5} required />
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" type="submit" className="fw-semibold">Send Message</Button>
            </Form>
            {/* Success and error messages can be handled with state */}
          </div>
        </Col>
      </Row>
    </Container>
  </section>
);

export default Contact; 













